module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-05.da77ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-05.jpg
// module id = Hzvf
// module chunks = 1